import React, { useEffect, useState } from "react";
import Header from "./Header";
import "./index.css";

const LivePage = () => {
  const [animation, setAnimation] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAnimation(true);
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  return (
    <div className={`header-view ${animation ? "active" : ""}`}>
      <Header />
    </div>
  );
};

export default LivePage;
